import { HelpItemTypeEnum } from "../../Enum/HelpItemTypeEnum";
import BaseEntity from "../BaseEntity.model";
import { CreatedBy } from "../Shared/CreatedBy.model";

export default interface IHelpItem extends BaseEntity {
    Title: string;
    Description: string;
    Type: HelpItemTypeEnum;
    Url: string;
    CreatedBy?: CreatedBy;
    UpdatedBy?: CreatedBy;
}

export class HelpItem implements IHelpItem {
    Id: string
    Title: string;
    Description: string;
    Type: HelpItemTypeEnum;
    Url: string;
    // CreatedBy: CreatedBy;
    // UpdatedBy: CreatedBy;
    constructor() {
        this.Id = '';
        this.Title = '';
        this.Description = '';
        this.Type = HelpItemTypeEnum.VIDEO;
        this.Url = '';
    }
};